import { render, staticRenderFns } from "./OrderDetailsContent.vue?vue&type=template&id=9e3de37e&scoped=true"
import script from "./OrderDetailsContent.vue?vue&type=script&lang=ts"
export * from "./OrderDetailsContent.vue?vue&type=script&lang=ts"
import style0 from "./OrderDetailsContent.vue?vue&type=style&index=0&id=9e3de37e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e3de37e",
  null
  
)

export default component.exports